import { Component } from '@angular/core';
import { SignalDesignModule } from 'src/app/signal-design/signal-design.module';

@Component({
    selector: 'app-notifications-toggle',
    standalone: true,
    imports: [SignalDesignModule],
    templateUrl: './notifications-toggle.component.html',
    styleUrl: './notifications-toggle.component.scss'
})
export class NotificationsToggleComponent {

}
